import React, { useContext } from 'react';
import { Button } from 'reactstrap';
import _ from "lodash";
import { AuthContext } from "contexts/AuthContext";

export const ListItem = ({ user, setUserToEdit }) => {
    const { state } = useContext(AuthContext);
    const date = new Date(user.created_at);

    const formattedDate = new Intl.DateTimeFormat('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    }).format(date);

    return (
        <tr>
            <td
                data-label="Email"
                className="alert-list-td"
            >
                {user.email}
            </td>
            <td
                data-label="Roles"
                className="alert-list-td"
            >
                {user.roles.map((role, i) => user.roles.length - 1 > i
                    ? (role.replaceAll(/role/gi, '').replaceAll('_', ' ') + ', ')
                    : role.replaceAll(/role/gi, '').replaceAll('_', ' ')
                )}
            </td>
            <td
                data-label="CreatedAt"
                className="alert-list-td"
            >
                {formattedDate}
            </td>

            <td data-label="Actions">{user.email !== state.profile.email &&
                <div className="responsive-table__edit-block">
                    <Button
                        color="light"
                        onClick={() => setUserToEdit(user)}
                    >
                        <i className="fa fa-pencil fa-lg"/>
                    </Button>
                </div>
            }
            </td>
        </tr>
    );
};
